import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';




function UploadFile() {
    const [files, setFiles] = useState([])
    const [uploaded, setUploaded] = useState(null);
    const [isVisible, setIsVisible] = useState(false)
    const navigate = useNavigate();


    useEffect(() => {
        if (uploaded === 100) {
            setIsVisible(true)
            setTimeout(() => {
                navigate('/filemanager');
            }, 2000);

        }
    })

    const hiddenFileInput = useRef(null);
    const handleClick = event => {
        hiddenFileInput.current.click();
    }
    const formData = new FormData();
    const upload = () => {
        for (let i = 0; i < files.length; i++) {
            formData.append(`files`, files[i], files[i].name);
        }

        const config = {
            onUploadProgress: progressEvent => setUploaded(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }

        axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/upload`, formData, config)
            .then(res => { }).catch(err => console.log(err))


    }

    const deleteFile = (e) => {
        e.preventDefault();
        // console.log(e.target.value);
        setFiles(Object.values(files).filter(item => item.name !== e.target.value))
    }


    return (
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
            <div className="mb-6">
                <h1 className="text-xl font-semibold text-slate-800">Uploader des vidéos</h1>
                <p className="text-sm text-slate-500">Sélectionnez un ou plusieurs fichiers .mp4 à envoyer.</p>
            </div>

            <main>
                <div className="w-full">

                    <div
                        className="mb-6 cursor-pointer rounded-2xl border-2 border-dashed border-slate-300 bg-slate-50 p-8 text-center text-slate-500 hover:border-indigo-400 hover:bg-indigo-50/30"
                        onClick={handleClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mx-auto mb-3 h-10 w-10 text-slate-400">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
                        </svg>
                        <span className="text-sm font-medium">Cliquez pour sélectionner un fichier</span>
                    </div>
                    <input type='file' ref={hiddenFileInput} onChange={(e) => setFiles(e.target.files)} multiple accept='.mp4' className='hidden'></input>
                    <div className="my-6 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                        <div className="overflow-x-auto">
                            <table className="w-full text-left text-sm text-slate-700">
                                <thead className="border-b border-slate-200 bg-slate-50">
                                    <tr>
                                        <th scope="col" className="w-full px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
                                            Nom du fichier
                                        </th>
                                        <th scope="col" className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                            </svg>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {files.length !== 0 ? Array.from(files).map((data, index) => {
                                        return (
                                            <tr className="border-b border-slate-100 hover:bg-indigo-50/40"  >

                                                <td className="px-4 py-3 text-sm font-semibold text-slate-800">
                                                    {data.name}
                                                </td>
                                                <td className="px-4 py-3 text-center" >
                                                    <button value={data.name} className="font-medium text-red-600 hover:underline" onClick={deleteFile} >X</button>
                                                </td>
                                            </tr>
                                        )
                                    }) :   <tr className="border-b border-slate-100"  ></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {uploaded &&
                        <div className="my-4 w-full rounded-full bg-slate-200">
                            <div className="rounded-full bg-indigo-500 p-0.5 text-center text-xs font-medium leading-none text-white" style={{ width: `${uploaded}%` }}>{`${uploaded}%`}</div>
                        </div>
                    }
                    <div className="m-auto w-full text-center">
                        <button className="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700" onClick={upload}>
                            <svg className="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" /></svg>
                            <span>Upload</span>
                        </button>
                    </div>
                </div>
            </main>

            {isVisible &&
                <div id="toast-success" className="absolute left-1/2 top-4 mb-4 flex w-full max-w-xs items-center rounded-xl border border-slate-200 bg-white p-4 text-slate-600 shadow-lg" role="alert">
                    <div className="inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
                        <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                        </svg>
                        <span className="sr-only">Check icon</span>
                    </div>
                    <div className="ml-3 text-sm font-normal">Fichier uploadé avec succès.</div>
                    <button type="button" className="-mx-1.5 -my-1.5 ml-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-white p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-900 focus:ring-2 focus:ring-slate-200" data-dismiss-target="#toast-success" aria-label="Close" onClick={() => setIsVisible(false)}>
                        <span className="sr-only">Close</span>
                        <svg className="h-3 w-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                    </button>
                </div>
            }


        </div>
    )
}
export default UploadFile;